import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-first-time-register-issuer-route-popup',
    templateUrl: './first-time-register-issuer-route-popup.component.html',
    styleUrls: ['./first-time-register-issuer-route-popup.component.scss'],
    standalone: false
})
export class FirstTimeRegisterIssuerRoutePopupComponent {
  constructor(public activeModal: NgbActiveModal) {}
  isNextPage: boolean = false;
  stay() {
    this.activeModal.dismiss('stay'); // user chooses to stay
  }

  explore() {
    this.activeModal.close('explore'); // user confirms action
  }
  ecf() {
    this.activeModal.close('ecf'); // user confirms action
  }
  tcf() {
    this.activeModal.close('tcf'); // user confirms action
  }
  nextpage() {
    this.isNextPage = true;
  }
  backpage() {
    this.isNextPage = false;
  }
}
